import Icon from '../components/Icon.vue'

Icon.register({
  medkit: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M96 480H416V128H384V80C384 53.5 362.5 32 336 32H176C149.5 32 128 53.5 128 80V128H96V480zM192 96H320V128H192V96zM512 176V432C512 458.5 490.5 480 464 480H448V128H464C490.5 128 512 149.5 512 176zM64 480H48C21.5 480 0 458.5 0 432V176C0 149.5 21.5 128 48 128H64V480zM352 272V304C352 312.8 344.8 320 336 320H288V368C288 376.8 280.8 384 272 384H240C231.2 384 224 376.8 224 368V320H176C167.2 320 160 312.8 160 304V272C160 263.2 167.2 256 176 256H224V208C224 199.2 231.2 192 240 192H272C280.8 192 288 199.2 288 208V256H336C344.8 256 352 263.2 352 272z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/medkit.js
// module id = zKKx
// module chunks = 144